import { Box, Typography } from "@mui/material";
import {
	type AccountSummaryRow,
	EMPTY,
	HEADER_FIELD_HELP,
} from "../models/SummaryByCloseDate";

/**
 * Label and value on one line, the way the legacy prints them. The labels are kept
 * verbatim, colon included: operators read the sheet by them.
 */
export const HeaderField = ({
	label,
	value,
	help = HEADER_FIELD_HELP[label],
}: {
	label: string;
	value: string;
	help?: string;
}) => (
	<Box sx={{ display: "flex", alignItems: "baseline", gap: 0.75 }} title={help}>
		<Typography variant="body2" color="text.secondary">
			{label}
		</Typography>
		<Typography
			variant="body2"
			sx={{ fontWeight: 600, fontVariantNumeric: "tabular-nums" }}
		>
			{value}
		</Typography>
	</Box>
);

interface Props {
	summary: AccountSummaryRow;
}

export const AccountSummaryHeader = ({ summary }: Props) => (
	<Box
		sx={{
			display: "flex",
			alignItems: "baseline",
			flexWrap: "wrap",
			columnGap: 4,
			rowGap: 0.5,
			px: 2,
			pt: 1.5,
			pb: 1.25,
		}}
	>
		<HeaderField label="Start Date:" value={summary.StartDateString ?? EMPTY} />
		<HeaderField label="Close Date:" value={summary.CloseDateString ?? EMPTY} />
		<Box sx={{ flexGrow: 1, minWidth: 8 }} />
		<HeaderField
			label="G/L Account Number:"
			value={summary.CostCenterName ?? EMPTY}
		/>
	</Box>
);
